window.$ = window.jQuery = require('jquery');
require('owl.carousel');
require('@fancyapps/fancybox');

import './components/tabs';
import './components/accordion-list';
import './components/header';
import './components/header-search';
import './components/search-results';
import './components/table-wrapper';
import './components/video-modal';
import './components/cookie-consent-banner';
import './components/form-section';
import './components/form-inputs';
import '@fancyapps/fancybox/dist/jquery.fancybox.css';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'tippy.js/dist/tippy.css';

require('./components/hero-slider');
require('./components/loan-calculator');
